import { render, staticRenderFns } from "./BlockchainDataTable.vue?vue&type=template&id=d3b03096&scoped=true&"
import script from "./BlockchainDataTable.vue?vue&type=script&lang=ts&"
export * from "./BlockchainDataTable.vue?vue&type=script&lang=ts&"
import style0 from "./BlockchainDataTable.vue?vue&type=style&index=0&id=d3b03096&scoped=true&lang=scss&"
import style1 from "./BlockchainDataTable.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3b03096",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
